import React from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import MenuLabel from "../parts/MenuLabel";

const MechanicalMenu = ({ 
    state, 
    isPathActive, 
    toggleMenuState, 
    arrayFeatures, 
    navigate,
    userData,
    jobTitle
}) => {
    return (
        <>
            {/* Batch Tracker */}
            {arrayFeatures?.includes("Batch Tracker") && (
                <li className={isPathActive("/batch-tracker") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.appsMenuOpen ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("appsMenuOpen");
                            navigate("/batch-tracker/app");
                        }}
                        data-toggle="collapse"
                    >
                        <i className="ti-layout menu-icon"></i>
                        <span className="menu-title">Batch Tracker</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.appsMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/batch-tracker/app") ? "nav-link active" : "nav-link"}
                                    to="/batch-tracker/app"
                                >
                                    App
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/batch-tracker/csv-export") ? "nav-link active" : "nav-link"}
                                    to="/batch-tracker/csv-export"
                                >
                                    CSV Export
                                </Link>
                            </li>
                        </ul>
                    </Collapse>
                </li>
            )}
            
            {/* Production Staging */}
            {arrayFeatures?.includes("Production Staging") && (
                <li className={isPathActive("/staging") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.staging ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("staging");
                            navigate("/staging/app");
                        }}
                        data-toggle="collapse"
                    >
                        <i className="ti-folder menu-icon"></i>
                        <span className="menu-title">Production Staging</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.staging}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/staging/app") ? "nav-link active" : "nav-link"}
                                    to="/staging/app"
                                >
                                    App
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/staging/summary") ? "nav-link active" : "nav-link"}
                                    to="/staging/summary"
                                >
                                    Summary Report
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/staging/csv-export") ? "nav-link active" : "nav-link"}
                                    to="/staging/csv-export"
                                >
                                    CSV Export
                                </Link>
                            </li>
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* Receiving */}
            {arrayFeatures?.includes("Receiving") && (
                <li className={isPathActive("/receiving") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.receiving ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("receiving");
                            navigate("/receiving/app");
                        }}
                        data-toggle="collapse"
                    >
                        <i className="ti-package menu-icon"></i>
                        <span className="menu-title">Receiving</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.receiving || state.report}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/receiving/app") ? "nav-link active" : "nav-link"}
                                    to="/receiving/app"
                                >
                                    App
                                </Link>
                            </li>
                            <li className="nav-item">
                                <div
                                    onClick={() => toggleMenuState("report")}
                                    className={state.report ? "nav-link active" : "nav-link"}
                                >
                                    <span className="menu-title">Reports</span>
                                    <i className="menu-arrow"></i>
                                </div>
                                <Collapse in={state.report}>
                                    <ul className="nav flex-column sub-menu" style={{ marginLeft: "-30px" }}>
                                        {arrayFeatures?.includes("Backorder Report") && (
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/receiving/backorder-report") ? "nav-link active" : "nav-link"}
                                                    to="/receiving/backorder-report"
                                                >
                                                    <MenuLabel label="Backorder" badgeColor="info" badgeText="BETA" />
                                                </Link>
                                            </li>
                                        )}
                                        {arrayFeatures?.includes("OTIF Report") && (
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/receiving/otif-report") ? "nav-link active" : "nav-link"}
                                                    to="/receiving/otif-report"
                                                >
                                                    OTIF
                                                </Link>
                                            </li>
                                        )}
                                        {arrayFeatures?.includes("Receiving Report") && (
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/receiving/csv-export") ? "nav-link active" : "nav-link"}
                                                    to="/receiving/csv-export"
                                                >
                                                    Receiving
                                                </Link>
                                            </li>
                                        )}
                                        {arrayFeatures?.includes("Tracking Receipts") && (
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/receiving/tracking-receipt-report") ? "nav-link active" : "nav-link"}
                                                    to="/receiving/tracking-receipt-report"
                                                >
                                                    Tracking Receipts
                                                </Link>
                                            </li>
                                        )}
                                        {arrayFeatures?.includes("Production Planning") && (
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/receiving/receiving-for-production-planning") ? "nav-link active" : "nav-link"}
                                                    to="/receiving/receiving-for-production-planning"
                                                >
                                                    Production <br /> Planning Receipts
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </Collapse>
                            </li>
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* Supply Chain Catalog */}
            {arrayFeatures?.includes("Supply Chain Catalog") && (
                <li className={isPathActive("/supply-chain-catalog/") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.supplyChainCatalog ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("supplyChainCatalog");
                            navigate("/supply-chain-catalog/search-materials");
                        }}
                    >
                        <i className="ti-layout menu-icon"></i>
                        <span className="menu-title">Supply Chain Catalog</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.supplyChainCatalog}>
                        <ul className="nav flex-column sub-menu">
                            {/* Material Orders - Only for Mechanical */}
                            {arrayFeatures?.includes("Material Orders") && (
                                <li className="nav-item">
                                    <div
                                        className={isPathActive("/supply-chain-catalog/material-orders") ? "nav-link active" : "nav-link"}
                                        onClick={() => navigate("/supply-chain-catalog/material-orders")}
                                    >
                                        <span className="menu-title">Material Orders</span>
                                    </div>
                                </li>
                            )}
                            
                            {/* Requisition List */}
                            {arrayFeatures?.includes("Requisition List") && (
                                <li className="nav-item">
                                    <div
                                        className={isPathActive("/supply-chain-catalog/requisition-list") ? "nav-link active" : "nav-link"}
                                        onClick={() => {
                                            toggleMenuState("requisitionList");
                                            navigate("/supply-chain-catalog/requisition-list/material-requisition");
                                        }}
                                    >
                                        <span className="menu-title">
                                            Requisition List
                                        </span>
                                        <i className="menu-arrow"></i>
                                    </div>
                                    <Collapse in={state.requisitionList}>
                                        <ul className="nav flex-column sub-menu" style={{ marginLeft: "-30px" }}>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/supply-chain-catalog/requisition-list/vdc-requisition") ? "nav-link active" : "nav-link"}
                                                    to="/supply-chain-catalog/requisition-list/vdc-requisition"
                                                >
                                                    Design Requisitions
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/supply-chain-catalog/requisition-list/material-requisition") ? "nav-link active" : "nav-link"}
                                                    to="/supply-chain-catalog/requisition-list/material-requisition"
                                                >
                                                    Field/Shop <br /> Requisitions
                                                </Link>
                                            </li>
                                        </ul>
                                    </Collapse>
                                </li>
                            )}
                            
                            {/* Search Materials */}
                            {arrayFeatures?.includes("Search Materials") && (
                                <li className="nav-item">
                                    <Link
                                        className={isPathActive("/supply-chain-catalog/search-materials") ? "nav-link active" : "nav-link"}
                                        to="/supply-chain-catalog/search-materials"
                                    >
                                        Search Materials
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* Purchasing */}
            {arrayFeatures?.includes("Purchasing") && (
                <li className={isPathActive("/purchasing") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.purchasing ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("purchasing");
                            navigate("/purchasing/bulk-po");
                        }}
                        data-toggle="collapse"
                    >
                        <i className="ti-folder menu-icon"></i>
                        <span className="menu-title">Purchasing</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.purchasing}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/purchasing/bulk-po") ? "nav-link active" : "nav-link"}
                                    to="/purchasing/bulk-po"
                                >
                                    Bulk PO
                                </Link>
                            </li>
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* Readers */}
            {arrayFeatures?.includes("Readers") && (
                <li className={isPathActive("/readers") ? "nav-item active" : "nav-item"}>
                    <div
                        className="nav-link"
                        onClick={() => navigate("/readers")}
                    >
                        <i className="ti-bar-chart menu-icon"></i>
                        <span className="menu-title">Readers</span>
                    </div>
                </li>
            )}

            {/* Supply Chain Reports */}
            {arrayFeatures?.includes("Supply Chain Reports") && (
                <li className={isPathActive("/supply-chain/reports") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.supply_chain_reports ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => navigate("/supply-chain/reports")}
                    >
                        <i className="ti-bar-chart menu-icon"></i>
                        <span className="menu-title">Reports</span>
                    </div>
                </li>
            )}

            {/* Total Station Scheduler */}
            {arrayFeatures?.includes("Total Station Scheduler") && (
                <li className={isPathActive("/total-station-scheduler") ? "nav-item active" : "nav-item"}>
                    <div
                        className={state.total_station ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("total_station");
                            navigate("/total-station-scheduler/app");
                        }}
                    >
                        <i className="ti-time menu-icon"></i>
                        <span className="menu-title">
                            Total Station   
                        </span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.total_station}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/total-station-scheduler/app") ? "nav-link active" : "nav-link"}
                                    to="/total-station-scheduler/app"
                                >
                                    Total Station List
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/total-station-scheduler/calendar") ? "nav-link active" : "nav-link"}
                                    to="/total-station-scheduler/calendar"
                                >
                                    Calendar View
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={isPathActive("/total-station-scheduler/reschedule") ? "nav-link active" : "nav-link"}
                                    to="/total-station-scheduler/reschedule"
                                >
                                    Reschedule Appointment
                                </Link>
                            </li>
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* VDC */}
            {arrayFeatures?.includes("VDC") && (
                <li className={
                    isPathActive("/spooling") ||
                    isPathActive("/batch-plan") ||
                    isPathActive("/task-scheduler")
                    ? "nav-item active" 
                    : "nav-item"
                }>
                    <div
                        className={state.vdc ? "nav-link menu-expanded" : "nav-link"}
                        onClick={() => {
                            toggleMenuState("vdc");
                            navigate("/batch-plan/app");
                        }}
                    >
                        <i className="ti-layout-grid2-thumb menu-icon"></i>
                        <span className="menu-title">VDC</span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={state.vdc}>
                        <ul className="nav flex-column sub-menu">
                            {arrayFeatures?.includes("Batch Plan") && (
                                <li className="nav-item">
                                    <div
                                        className={isPathActive("/batch-plan") ? "nav-link active" : "nav-link"}
                                        onClick={() => navigate("/batch-plan/app")}
                                    >
                                        <span className="menu-title">Batch Approval</span>
                                    </div>
                                </li>
                            )}
                            
                            {arrayFeatures?.includes("Spooling Approval") && (
                                <li className="nav-item">
                                    <div
                                        className={isPathActive("/spooling") ? "nav-link active" : "nav-link"}
                                        onClick={() => {
                                            toggleMenuState("spooling");
                                            navigate("/spooling/app");
                                        }}
                                    >
                                        <span className="menu-title">
                                            Spooling Approval
                                        </span>
                                        <i className="menu-arrow"></i>
                                    </div>
                                    <Collapse in={state.spooling}>
                                        <ul className="nav flex-column sub-menu" style={{ marginLeft: "-30px" }}>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/spooling/app") ? "nav-link active" : "nav-link"}
                                                    to="/spooling/app"
                                                >
                                                    App
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/spooling/summary") ? "nav-link active" : "nav-link"}
                                                    to="/spooling/summary"
                                                >
                                                    Summary Report
                                                </Link>
                                            </li>
                                        </ul>
                                    </Collapse>
                                </li>
                            )}
                            
                            {/* Task Scheduler - only for VDC users or superusers */}
                            {arrayFeatures?.includes("Task Scheduler") &&
                                (userData?.user?.is_superuser || jobTitle?.includes("vdc")) && (
                                <li className="nav-item">
                                    <div
                                        className={isPathActive("/task-scheduler") ? "nav-link active" : "nav-link"}
                                        onClick={() => {
                                            toggleMenuState("task_scheduler");
                                            navigate("/task-scheduler/list");
                                        }}
                                    >
                                        <span className="menu-title">
                                            Task Scheduler
                                        </span>
                                        <i className="menu-arrow"></i>
                                    </div>
                                    <Collapse in={state.task_scheduler}>
                                        <ul className="nav flex-column sub-menu" style={{ marginLeft: "-30px" }}>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/task-scheduler/list") ? "nav-link active" : "nav-link"}
                                                    to="/task-scheduler/list"
                                                >
                                                    Task List
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className={isPathActive("/task-scheduler/calendar") ? "nav-link active" : "nav-link"}
                                                    to="/task-scheduler/calendar"
                                                >
                                                    Calendar View
                                                </Link>
                                            </li>
                                        </ul>
                                    </Collapse>
                                </li>
                            )}
                        </ul>
                    </Collapse>
                </li>
            )}

            {/* Material Catalog */}
            {arrayFeatures?.includes("Material Catalog") && (
                <li className={isPathActive("/material-catalog") ? "nav-item active" : "nav-item"}>
                    <div
                        className="nav-link"
                        onClick={() => navigate("/material-catalog")}
                    >
                        <i className="ti-agenda menu-icon"></i>
                        <span className="menu-title">
                            <Link className="menu-title" to="/material-catalog">
                                Material Catalog
                            </Link>
                        </span>
                    </div>
                </li>
            )}
        </>
    );
};

export default MechanicalMenu;